import { MetadataValueTypes } from "@cube3/common/model/schema/resources/metadata-field-type"
import { useCurrentWorkspace } from "@cube3/state/src/redux/components/Administration/withCurrentWorkspace"
import { useResourceList__ALPHA } from "@cube3/state/src/redux/components/Hooks/useResourceList"
import { useMemo } from "react"

export const useFieldTypeSchemas = () => {
    const [workspaceId] = useCurrentWorkspace()

    const { resources: fieldTypes, status: fieldTypesStatus } = useResourceList__ALPHA({
        resourceId: workspaceId,
        resourceType: 'workspace',
        edgeType: 'metadata-field-type',
        edgeLabel: 'metadata-field-types'
    })

    const fieldTypeSchemas = useMemo(() => {
        return fieldTypes.reduce((acc, val) => {
            acc[val.id] = val.json_schema
            return acc
        }, {} as Record<MetadataValueTypes, string>)
    }, [fieldTypes])

    return { fieldTypeSchemas, fieldTypes, fieldTypesStatus }
}